import ReactApexChart from "react-apexcharts";
import { SERIES, TEXTO_EIXO, baseChartOptions, barPlotOptions, barDataLabels } from "./chartTheme";
import { formatNumber } from "./crmHelpers";

/*
  Carga dos próximos 14 dias.

  Responde a pergunta que uma lista de tarefas nunca responde: **quando sobra
  tempo?** Ver "12 tarefas futuras" não ajuda a decidir se dá para assumir mais
  uma; ver que quinta tem quatro e sexta tem zero, sim.

  Os dias vazios aparecem como coluna zerada, nunca omitidos: um calendário que
  pula os dias sem tarefa comprime a escala e esconde exatamente a folga que se
  está procurando.
*/

const DIAS_SEMANA = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];

const rotuloDia = (iso) => {
  const [ano, mes, dia] = iso.split("-").map(Number);
  // Montado por componentes: `new Date("2026-10-08")` é meia-noite UTC e, no
  // fuso -03:00, volta um dia — o gráfico mostraria a carga deslocada.
  const data = new Date(ano, mes - 1, dia);
  return `${DIAS_SEMANA[data.getDay()]} ${String(dia).padStart(2, "0")}`;
};

const WorkloadChart = ({ workload = [], height = 150 }) => {
  if (!workload.length) return null;

  const categorias = workload.map((item) => rotuloDia(item.date));
  const hoje = new Date().toISOString().slice(0, 10);

  const options = {
    ...baseChartOptions(categorias, {
      xaxis: {
        labels: {
          style: { colors: TEXTO_EIXO, fontSize: "10px" },
          rotate: 0,
          hideOverlappingLabels: true,
        },
      },
      yaxis: {
        labels: {
          style: { colors: TEXTO_EIXO, fontSize: "10px" },
          formatter: (value) => Math.round(value),
        },
        // Sem isso o eixo vira 0 / 0,5 / 1 numa semana de poucas tarefas.
        tickAmount: 3,
        min: 0,
      },
    }),
    plotOptions: barPlotOptions(),
    // Dia sem tarefa não ganha um "0" flutuando: a coluna ausente já diz isso.
    dataLabels: barDataLabels((value) => (value > 0 ? value : "")),
    /*
      Hoje em laranja, o resto em azul. É a única referência que o eixo não
      dá sozinho — sem ela a pessoa conta as colunas para achar onde está.
    */
    colors: [
      ({ dataPointIndex }) =>
        workload[dataPointIndex]?.date === hoje
          ? SERIES.secundaria
          : SERIES.primaria,
    ],
    tooltip: {
      shared: false,
      intersect: true,
      style: { fontSize: "12px", fontFamily: "inherit" },
      y: {
        formatter: (value) =>
          value === 1 ? "1 tarefa" : `${formatNumber(value)} tarefas`,
      },
    },
  };

  return (
    <ReactApexChart
      type="bar"
      height={height}
      options={options}
      series={[{ name: "Tarefas", data: workload.map((item) => item.total) }]}
    />
  );
};

export default WorkloadChart;
